// extracted by mini-css-extract-plugin
export default {"walletOptions":"styles_walletOptions__j845r","error":"styles_error__cjrgU","loader":"styles_loader__0Z4bQ"};